<style>
    .notification-item {
        border-radius: 4px;
        margin: 5px 0;
        background-color: white;
        padding: 10px 5px 10px 20px;
		position: relative;
    }
    .notification-item.night-mode {
		background-color: #002340;
		color: white;
    }
    .notification-title {
        display: flex;
    }
	.notification-action {
		cursor: pointer;
		z-index: 6005;
	}
	.notification-dimiss {
		padding: 0 10px;
		position: absolute;
		top: 5px;
		right: 0px;
	}
	.notification-expand {
		padding: 0 10px;
		position: absolute;
		bottom: 5px;
		right: 0px;
	}
	.notification-approve {
		padding: 0 10px;
		position: absolute;
		bottom: 5px;
		right: 125px;
		font-weight: bold;
	}
	.full-width {
		min-width: 800px;
		width: 100%;
	}
	.template {
		padding-top: 20px;
	}
	.loading {
		position: inherit;
		top: 50%;
		left: 50%;
	}
</style>
<div *ngFor="let category of notificationCategories" style="background-color: transparent;">
	<h2 style="color: white; display: flex; cursor: pointer;" (click)="category.expanded = !category.expanded;">
		{{category.name}}&nbsp;&middot;&nbsp;{{activeView?category.count:category.dismissedCount}}&nbsp;&nbsp;
		<i class="fa fa-2x fa-angle-down" style="margin-top: -5px;" *ngIf="!category.expanded"></i>
		<i class="fa fa-2x fa-angle-up" style="margin-top: -7px;" *ngIf="category.expanded"></i>
	</h2>
	<div *ngIf="category.expanded">
		<div class="notification-item" 
			[@dismissAnimation]="notification.dismissAnimation" 
			[@dismissAnimationHide]="notification.dismissAnimation" 
			[ngClass]="{'night-mode': nightMode}" 
			*ngFor="let notification of category.notifications">
			<div class="notification-title">
				<div class="full-width">
					<i class="fa {{getIcon(notification.title, notification.errorMessage, notification.warningMessage)}} fa-lg" 
						[ngClass]="{'rail360-danger': !!notification.errorMessage, 'rail360-warning': !!notification.warningMessage}"
						style="padding-right: 10px"></i>
					<label class="label-lg rail360-accent" style="font-weight: bold" *ngIf="!notification.navigateUrl">{{notification.title}}</label>
					<a (click)="navigateToUrl(notification, category)" *ngIf="notification.navigateUrl">
						<label class="label-lg rail360-accent notification-action" style="font-weight: bold">{{notification.title}}</label>
					</a>
					&nbsp;&middot;&nbsp;<label class="label-lg" [ngClass]="{'night-mode': nightMode}">{{notification.ageOfMessage}}</label>
				</div>
				<div class="notification-action notification-dimiss" *ngIf="activeView" (click)="dismissNotificationToAllUser(category, notification);">X</div>
				<div class="notification-action notification-expand" (click)="toggleExpandNotification(notification);" *ngIf="getExpandedContent(notification) !== null">
					<i class="fa fa-lg" [ngClass]="{'fa-angle-down': !notification.isExpanded, 'fa-angle-up': notification.isExpanded }"></i>
				</div>
				<button class="notification-action notification-approve rail360-accent btn-link" (click)="approve(notification, category)" *ngIf="getExpandedContent(notification) !== null  && showApproveButton(notification)" [disabled]="isLoading || !activeView">Approve</button>
				<button class="notification-action notification-approve rail360-accent btn-link" (click)="review(notification)" *ngIf="showReviewButton(notification)" [disabled]="isLoading || !activeView">Review</button>
			</div>
			<div [innerHTML]="notification.message"></div>
			<div *ngIf="notification.oldValue !== notification.newValue" class="rail360-accent">Value for {{notification.fieldName}} has changed from {{notification.oldValue}} to {{notification.newValue}}.</div>
			<div *ngIf="!!notification.errorMessage" [innerHTML]="notification.errorMessage" class="rail360-danger"></div>
			<div *ngIf="!!notification.warningMessage" [innerHTML]="notification.warningMessage" class="rail360-warning"></div>
			<div *ngIf="!notification.isLoading else loading" class="full-width"></div>
			<div *ngIf="notification.isExpanded" class="full-width template" style="padding: 10px 0;">
				<div *ngIf="notification.templateData else loading">
					<ng-container *ngTemplateOutlet="getExpandedContent(notification);context:notification"></ng-container>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #railcarCPdTemplate let-context="templateData">
	<notification-railcar-cpd 
		[data]="context"
		[nightMode]="nightMode"
		(cpDateChanged)="valueChanged($event)">
	</notification-railcar-cpd>
</ng-template>

<ng-template #traceResultsWithEditFields let-context="templateData">
	<notification-edit-feild
		[context]="context"
		[nightMode]="nightMode"
		[destinationToStorage]="destinationToStorage"
		(cpDateChanged)="valueChanged($event)"
		(requestRecieverForm) = "receiverFormChange($event)">
	</notification-edit-feild>
</ng-template>

<ng-template #traceResults let-context="templateData">
	<notification-trace-results
		[traceResults]="context"
		[nightMode]="nightMode">
	</notification-trace-results>
</ng-template>

<ng-template #loading>
	<div style="height: 100%;">
		<span class="k-loading-image loading"></span>
	</div>
</ng-template>